@let matchedVideos = matchedTutorialVideos$ | async;
@if (matchedVideos && matchedVideos.length > 0) {
  <div
    class="need-some-help-container"
    [class.sidenav-closed]="!(sidenavVisible$ | async)"
    [class.sidenav-open]="sidenavVisible$ | async"
    (click)="openTutorialVideoPopUp(matchedVideos)"
    *ngrxLet="showingVideo$ as showingVideo"
    [ngClass]="showingVideo ? 'hidden' : 'visible'"
    matRipple
  >
    <gb-icon [height]="'36px'" [icon]="'help-circle'"></gb-icon>
    <div class="need-some-help-text">
      <div class="need-some-help-text-inner">
        <span translate="STAFF.TUTORIAL_VIDEOS.NEED_SOME_HELP"></span>
        <span>
          <span translate="STAFF.TUTORIAL_VIDEOS.CHECKOUT_TUTORIAL_VIDEO"></span>
          <a (click)="goToHelpCenter()" translate="STAFF.TUTORIAL_VIDEOS.HELP_CENTER"></a>
        </span>
      </div>
    </div>
  </div>
}
